<template>
    <section class="join-section" ref="startForm" :style="{'scroll-margin-top':headerHeight}">
        <div v-if="plans.length === 0">
            <div>
                <h3 class="join-title">New Membership</h3>
            </div>

            <h4 class="join-title" style="color: red;">You need to add membership plans to the system.</h4>
        </div>
        <div v-if="plans.length > 0">
            <div>
                <h3 class="join-title">New Membership</h3>
            </div>

            <div class="join-form">
                <template v-if="form.step === 1">
                    <div class="step-box" style="border-bottom: none; padding-bottom: 0">
                        <div class="step-title">Membership Plan</div>

                        <div class="fields-wrap" style="margin-bottom: 32px;">
                            <div class="field-box">
                                <label class="field-label">Select Membership Plan <span class="field-required">*</span></label>
                                <div class="field-element">
                                    <select name="plan" style="width: 100%;" v-model="form.plan" @change="handlePlanChange">
                                        <option v-for="plan in plans" :key="plan.id" :value="plan.id">
                                            {{ plan.name }}
                                        </option>
                                    </select>
                                    <div class="error-messages">{{ messageFieldError('plan') }}</div>
                                </div>
                            </div>
                        </div>

                        <h4 class="title-table">Membership Plans Offered</h4>
                        <div class="plans-table-wrap">
                            <table class="plans-table">
                                <thead>
                                <tr>
                                    <td style="width: 25%;">Plan Name</td>
                                    <td style="width: 15%; text-align: center;">For</td>
                                    <td style="width: 15%; text-align: center;">Maximum Associated Members</td>
                                    <td style="width: 10%; text-align: center;">Annual Fee</td>
                                    <td style="width: 35%; text-align: center;">Description</td>
                                </tr>
                                </thead>

                                <tr v-for="plan in plans" :key="plan.id">
                                    <td>{{ plan.name }}</td>
                                    <td style="text-align: center;">{{ userTypes.find(t => t.id === plan.type)?.name ?? '' }}</td>
                                    <td style="text-align: center;">{{ plan.max_members }}</td>
                                    <td style="text-align: center;">
                                        <span class="font-weight-bold">{{ formatMoney(plan.annual_fee) }}</span> <span style="font-size: 0.8em; color: gray;">{{ currency }}</span>
                                    </td>
                                    <td>{{ plan.description }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </template>

                <template v-if="form.step === 2">
                    <div class="step-box">
                        <div class="step-title">Primary Member Information</div>

                        <div class="fields-wrap">
                            <template v-if="!isOrganization">
                                <div class="field-box">
                                    <label class="field-label">Prefix</label>
                                    <div class="field-element">
                                        <input type="text" style="width: 100%;" v-model="form.name_prefix" />
                                        <div class="error-messages">{{ messageFieldError('name_prefix') }}</div>
                                    </div>
                                </div>
                                <div class="field-box">
                                    <label class="field-label">First Name <span class="field-required">*</span></label>
                                    <div class="field-element">
                                        <input type="text" style="width: 100%;" v-model="form.first_name" />
                                        <div class="error-messages">{{ messageFieldError('first_name') }}</div>
                                    </div>
                                </div>
                                <div class="field-box">
                                    <label class="field-label">Preferred Name</label>
                                    <div class="field-element">
                                        <input type="text" style="width: 100%;" v-model="form.preferred_name" />
                                        <div class="error-messages">{{ messageFieldError('preferred_name') }}</div>
                                    </div>
                                </div>
                                <div class="field-box">
                                    <label class="field-label">Middle</label>
                                    <div class="field-element">
                                        <input type="text" style="width: 100%;" v-model="form.middle_name" />
                                        <div class="error-messages">{{ messageFieldError('middle_name') }}</div>
                                    </div>
                                </div>
                                <div class="field-box">
                                    <label class="field-label">Maiden Name</label>
                                    <div class="field-element">
                                        <input type="text" style="width: 100%;" v-model="form.maiden_name" />
                                        <div class="error-messages">{{ messageFieldError('maiden_name') }}</div>
                                    </div>
                                </div>
                                <div class="field-box">
                                    <label class="field-label">Last Name <span class="field-required">*</span></label>
                                    <div class="field-element">
                                        <input type="text" style="width: 100%;" v-model="form.last_name" />
                                        <div class="error-messages">{{ messageFieldError('last_name') }}</div>
                                    </div>
                                </div>
                                <div class="field-box">
                                    <label class="field-label">Suffix</label>
                                    <div class="field-element">
                                        <input type="text" style="width: 100%;" v-model="form.name_suffix" />
                                        <div class="error-messages">{{ messageFieldError('name_suffix') }}</div>
                                    </div>
                                </div>
                                <div class="field-box">
                                    <label class="field-label">Date of Birth</label>
                                    <div class="field-element" style="display: flex;">
                                        <select name="plan" style="flex-grow: 1; margin: 0 2px;" v-model="birthday.month">
                                            <option value="">---</option>
                                            <option v-for="(month, i) in monthList()" :key="i" :value="month.value">
                                                {{ month.text }}
                                            </option>
                                        </select>
                                        <select name="plan" style="width: 80px;" v-model="birthday.day">
                                            <option value="">---</option>
                                            <option v-for="(month, i) in daysListByMonth(birthday.month)" :key="i" :value="month.value">
                                                {{ month.text }}
                                            </option>
                                        </select>
                                        <input type="number" min="1000" :max="maxYear" step="1" style="width: 80px;" v-model="birthday.year" @focusout="checkBirthday" />
                                        <div class="error-messages">{{ messageFieldError('birthday') }}</div>
                                    </div>
                                </div>
                            </template>

                            <template v-if="isOrganization">
                                <div class="field-box">
                                    <label class="field-label">Name <span class="field-required">*</span></label>
                                    <div class="field-element">
                                        <input type="text" style="width: 100%;" v-model="form.organization_name" />
                                        <div class="error-messages">{{ messageFieldError('organization_name') }}</div>
                                    </div>
                                </div>
                                <div class="field-box">
                                    <label class="field-label">Contact</label>
                                    <div class="field-element">
                                        <input type="text" style="width: 100%;" v-model="form.contact" />
                                        <div class="error-messages">{{ messageFieldError('contact') }}</div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </template>

                <template v-if="form.step === 3">
                    <div class="step-box">
                        <div class="step-title">Main Contact Information</div>

                        <div class="fields-wrap">
                            <div class="field-box">
                                <label class="field-label">Address <span class="field-required">*</span></label>
                                <div class="field-element">
                                    <input type="text" style="width: 100%;" v-model="form.primaryContact.address_1" />
                                    <div class="error-messages">{{ messageFieldError('primaryContact.address_1') }}</div>
                                </div>
                            </div>
                            <div class="field-box">
                                <label class="field-label">Address 2</label>
                                <div class="field-element">
                                    <input type="text" style="width: 100%;" v-model="form.primaryContact.address_2" />
                                    <div class="error-messages">{{ messageFieldError('primaryContact.address_2') }}</div>
                                </div>
                            </div>
                            <div class="field-box">
                                <label class="field-label">City <span class="field-required">*</span></label>
                                <div class="field-element">
                                    <input type="text" style="width: 100%;" v-model="form.primaryContact.city" />
                                    <div class="error-messages">{{ messageFieldError('primaryContact.city') }}</div>
                                </div>
                            </div>
                            <div class="field-box">
                                <label class="field-label">State / Province <span class="field-required">*</span></label>
                                <div class="field-element">
                                    <input type="text" style="width: 100%;" v-model="form.primaryContact.state" />
                                    <div class="error-messages">{{ messageFieldError('primaryContact.state') }}</div>
                                </div>
                            </div>
                            <div class="field-box">
                                <label class="field-label">Postal Code <span class="field-required">*</span></label>
                                <div class="field-element">
                                    <input type="text" style="width: 100%;" v-model="form.primaryContact.postal_code" />
                                    <div class="error-messages">{{ messageFieldError('primaryContact.postal_code') }}</div>
                                </div>
                            </div>
                            <div class="field-box">
                                <label class="field-label">Country</label>
                                <div class="field-element">
                                    <input type="text" style="width: 100%;" v-model="form.primaryContact.country" />
                                    <div class="error-messages">{{ messageFieldError('primaryContact.country') }}</div>
                                </div>
                            </div>
                            <div class="field-box">
                                <label class="field-label">
                                    Phone
                                    <span v-if="publicSettings.join_form.make_require_phone_or_cell" class="field-required">*</span>
                                </label>
                                <div class="field-element">
                                    <input type="text" v-mask="phoneFormatMask" style="width: 100%;" v-model="form.primaryContact.phone" />
                                    <div class="error-messages">{{ messageFieldError('primaryContact.phone') }}</div>
                                </div>
                            </div>
                            <div class="field-box">
                                <label class="field-label">Cell Phone</label>
                                <div class="field-element">
                                    <input type="text" v-mask="phoneFormatMask" style="width: 100%;" v-model="form.primaryContact.cell_phone" />
                                    <div class="error-messages">{{ messageFieldError('primaryContact.cell_phone') }}</div>
                                </div>
                            </div>
                            <div class="field-box">
                                <label class="field-label">Int'l. Phone</label>
                                <div class="field-element">
                                    <input type="text" v-mask="phoneFormatMask" style="width: 100%;" v-model="form.primaryContact.int_phone" />
                                    <div class="error-messages">{{ messageFieldError('primaryContact.int_phone') }}</div>
                                </div>
                            </div>
                            <div class="field-box">
                                <label class="field-label">
                                    Email
                                    <span v-if="publicSettings.join_form.make_require_primary_email" class="field-required">*</span>
                                </label>
                                <div class="field-element">
                                    <input type="text" style="width: 100%;" v-model="form.email" />
                                    <div class="error-messages">{{ messageFieldError('email') }}</div>
                                </div>
                            </div>
                            <div class="field-box">
                                <label class="field-label">Website</label>
                                <div class="field-element">
                                    <input type="text" style="width: 100%;" v-model="form.website" />
                                    <div class="error-messages">{{ messageFieldError('website') }}</div>
                                </div>
                            </div>

                            <div class="field-box">
                                <label class="field-label">Do you have an alternate 'Seasonal' address:</label>
                                <div class="field-element">
                                    <select
                                        name="seasonalContact.uses_seasonal_contact"
                                        style="flex-grow: 1; margin: 0 2px; width: 100%;"
                                        v-model="form.seasonalContact.uses_seasonal_contact"
                                        :class="{'input-error': messageFieldError('seasonalContact.uses_seasonal_contact')}"
                                    >
                                        <option
                                            v-for="(option, index) in getOptionsWithEmptySlot(boolList, form.seasonalContact.uses_seasonal_contact, 'name', 'id')"
                                            :key="index"
                                            :value="option.id"
                                        >
                                            {{ option.name }}
                                        </option>
                                    </select>
                                </div>
                                <div class="error-messages">{{ messageFieldError('seasonalContact.uses_seasonal_contact') }}</div>
                            </div>
                        </div>
                    </div>
                </template>

                <template v-if="form.step === 4">
                    <div class="step-box">
                        <div class="step-title">Seasonal Contact Info</div>

                        <div class="fields-wrap">
                            <div class="field-box" v-if="form.seasonalContact.uses_seasonal_contact">
                                <label class="field-label">From: <span class="field-required">*</span></label>
                                <div class="date-select-row">
                                    <div class="date-select">
                                        <label class="field-label">Month</label>
                                        <select v-model="form.seasonalContact.season_start_month" style="width: 230px;">
                                            <option v-for="month in getOptionsWithEmptySlot(months, form.seasonalContact.season_start_month)"
                                                    :value="month.value"
                                                    :key="month.value">
                                                {{ month.text }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="date-select">
                                        <label class="field-label">Day</label>
                                        <select v-model="form.seasonalContact.season_start_day" style="width: 110px;">
                                            <option v-for="day in getOptionsWithEmptySlot(daysListByMonthPadded(form.seasonalContact.season_start_month), form.seasonalContact.season_start_day)"
                                                    :value="day.value"
                                                    :key="day.value">
                                                {{ day.text }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="error-messages">{{ messageFieldError('seasonalContact.season_start_month') }}</div>
                                <div class="error-messages">{{ messageFieldError('seasonalContact.season_start_day') }}</div>
                            </div>

                            <div class="field-box" v-if="form.seasonalContact.uses_seasonal_contact">
                                <label class="field-label">To: <span class="field-required">*</span></label>
                                <div class="date-select-row">
                                    <div class="date-select">
                                        <label class="field-label">Month</label>
                                        <select v-model="form.seasonalContact.season_end_month" style="width: 230px;">
                                            <option v-for="month in getOptionsWithEmptySlot(months, form.seasonalContact.season_end_month)"
                                                    :value="month.value"
                                                    :key="month.value">
                                                {{ month.text }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="date-select">
                                        <label class="field-label">Day</label>
                                        <select v-model="form.seasonalContact.season_end_day" style="width: 110px;">
                                            <option v-for="day in getOptionsWithEmptySlot(daysListByMonthPadded(form.seasonalContact.season_end_month), form.seasonalContact.season_end_day)"
                                                    :value="day.value"
                                                    :key="day.value">
                                                {{ day.text }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="error-messages">{{ messageFieldError('seasonalContact.season_end_month') }}</div>
                                <div class="error-messages">{{ messageFieldError('seasonalContact.season_end_day') }}</div>
                            </div>

                            <div class="field-box" v-if="form.seasonalContact.uses_seasonal_contact">
                                <label class="field-label">Country:</label>
                                <input type="text" v-model="form.seasonalContact.country" />
                                <div class="error-messages">{{ messageFieldError('seasonalContact.country') }}</div>
                            </div>

                            <div class="field-box" v-if="form.seasonalContact.uses_seasonal_contact">
                                <label class="field-label">State: <span class="field-required">*</span></label>
                                <input type="text" v-model="form.seasonalContact.state" />
                                <div class="error-messages">{{ messageFieldError('seasonalContact.state') }}</div>
                            </div>

                            <div class="field-box" v-if="form.seasonalContact.uses_seasonal_contact">
                                <label class="field-label">City: <span class="field-required">*</span></label>
                                <input type="text" v-model="form.seasonalContact.city" />
                                <div class="error-messages">{{ messageFieldError('seasonalContact.city') }}</div>
                            </div>

                            <div class="field-box" v-if="form.seasonalContact.uses_seasonal_contact">
                                <label class="field-label">Address: <span class="field-required">*</span></label>
                                <input type="text" v-model="form.seasonalContact.address_1" />
                                <div class="error-messages">{{ messageFieldError('seasonalContact.address_1') }}</div>
                            </div>

                            <div class="field-box" v-if="form.seasonalContact.uses_seasonal_contact">
                                <label class="field-label">Address 2:</label>
                                <input type="text" v-model="form.seasonalContact.address_2" />
                                <div class="error-messages">{{ messageFieldError('seasonalContact.address_2') }}</div>
                            </div>

                            <div class="field-box" v-if="form.seasonalContact.uses_seasonal_contact">
                                <label class="field-label">Postal Code: <span class="field-required">*</span></label>
                                <input type="text" v-model="form.seasonalContact.postal_code" />
                                <div class="error-messages">{{ messageFieldError('seasonalContact.postal_code') }}</div>
                            </div>

                            <div class="field-box" v-if="form.seasonalContact.uses_seasonal_contact">
                                <label class="field-label">Phone:</label>
                                <input type="text" v-mask="phoneFormatMask" v-model="form.seasonalContact.phone" />
                                <div class="error-messages">{{ messageFieldError('seasonalContact.phone') }}</div>
                            </div>

                            <div class="field-box" v-if="form.seasonalContact.uses_seasonal_contact">
                                <label class="field-label">Int'l Phone:</label>
                                <input type="text" v-mask="phoneFormatMask" v-model="form.seasonalContact.int_phone" />
                                <div class="error-messages">{{ messageFieldError('seasonalContact.int_phone') }}</div>
                            </div>
                        </div>
                    </div>
                </template>

                <template v-if="form.step === 5">
                    <div class="step-box">
                        <div class="step-title">Site Access</div>

                        <div class="fields-wrap">
                            <div class="field-box">
                                <label class="field-label">Login Name <span class="field-required">*</span></label>
                                <div class="field-element">
                                    <input type="text" style="width: 100%;" v-model="form.login" />
                                    <div class="error-messages">{{ messageFieldError('login') }}</div>
                                </div>
                            </div>
                            <div class="field-box">
                                <div class="hint-messages">
                                    {{ this.inputsHints.passwordValidity }}
                                </div>
                                <label class="field-label">Password <span class="field-required">*</span></label>
                                <div class="field-element password-field">
                                    <input :type="showPassword ? 'text' : 'password'" v-model="form.password" />
                                    <i
                                        :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"
                                        class="password-toggle"
                                        @click="showPassword = !showPassword"
                                    ></i>
                                    <div class="error-messages">{{ messageFieldError('password') }}</div>
                                </div>
                            </div>
                            <div class="field-box">
                                <label class="field-label">Retype Password <span class="field-required">*</span></label>
                                <div class="field-element password-field">
                                    <input :type="showPasswordConfirmation ? 'text' : 'password'" v-model="form.password_confirmation" />
                                    <i
                                        :class="showPasswordConfirmation ? 'fas fa-eye-slash' : 'fas fa-eye'"
                                        class="password-toggle"
                                        @click="showPasswordConfirmation = !showPasswordConfirmation"
                                    ></i>
                                    <div class="error-messages">{{ messageFieldError('password_confirmation') }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>

                <template v-if="form.step === 6">
                    <div class="step-title" style="border-bottom: none;">Please review all information to confirm accuracy before checking out</div>

                    <div style="margin-bottom: 16px;">
                        <div class="step-title">Membership Plan</div>

                        <div style="display: flex;">
                            <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">Plan:</div>
                            <div style="padding: 5px 0; font-weight: bold;">{{ selectedPlan.name }}</div>
                        </div>

                        <div
                            v-if="selectedPlan.max_renewal_years !== null"
                            style="display: flex;"
                        >
                            <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">
                                Number of Years:
                            </div>

                            <div style="padding: 2px 0;">
                                <input
                                    type="number"
                                    min="1"
                                    :max="selectedPlan.max_renewal_years"
                                    v-model.number="form.years"
                                    @change="normalizeYears"
                                    style="width: 80px;"
                                />

                                <div
                                    v-if="yearsError"
                                    style="color: red; font-size: 0.85em; margin-top: 4px;"
                                >
                                    {{ yearsError }}
                                </div>
                            </div>
                        </div>

                        <div style="display: flex;">
                            <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">Donation:</div>
                            <div style="padding: 2px 0;"><input type="number" min="0" step="1" style="width: 80px;" v-model="form.donation" /></div>
                        </div>

                        <div style="display: flex;">
                            <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">Payment Method:</div>
                            <div>
                                <select v-if="availablePaymentMethods.length > 0" style="max-width: 250px;" v-model="form.payment_type">
                                    <option disabled value="">Select a payment method</option>
                                    <option v-for="method in availablePaymentMethods" :key="method.code" :value="method.code">
                                        {{ method.name }}
                                    </option>
                                </select>
                                <div class="error-messages">
                                    <template v-if="availablePaymentMethods.length === 0">
                                        <div style="padding-top: 8px;">Payment methods are missing or not configured. Contact your administrator</div>
                                    </template>
                                    <template >
                                        {{ messageFieldError('payment_type') }}
                                    </template>
                                </div>
                            </div>
                        </div>

                        <div style="display: flex;">
                            <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">Tax:</div>
                            <div style="padding: 5px 0; font-weight: bold;">
                                <span>{{ tax }}</span> <span style="font-size: 0.8em; color: gray;">{{ currency }}</span>
                            </div>
                            <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">Total Due:</div>
                            <div style="padding: 5px 0; font-weight: bold;">
                                <span>{{ total }}</span> <span style="font-size: 0.8em; color: gray;">{{ currency }}</span>
                            </div>
                        </div>
                    </div>

                    <div style="margin-bottom: 16px;">
                        <div class="step-title">Primary Member Information</div>

                        <template v-if="!isOrganization">
                            <div style="display: flex;" v-if="form.name_prefix">
                                <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">Prefix:</div>
                                <div style="padding: 5px 0; font-weight: bold;">{{ form.name_prefix }}</div>
                            </div>

                            <div style="display: flex;">
                                <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">First Name:</div>
                                <div style="padding: 5px 0; font-weight: bold;">{{ form.first_name }}</div>
                            </div>

                            <div style="display: flex;" v-if="form.preferred_name">
                                <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">Preferred Name:</div>
                                <div style="padding: 5px 0; font-weight: bold;">{{ form.preferred_name }}</div>
                            </div>

                            <div style="display: flex;" v-if="form.middle_name">
                                <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">Middle:</div>
                                <div style="padding: 5px 0; font-weight: bold;">{{ form.middle_name }}</div>
                            </div>

                            <div style="display: flex;" v-if="form.maiden_name">
                                <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">Maiden Name:</div>
                                <div style="padding: 5px 0; font-weight: bold;">{{ form.maiden_name }}</div>
                            </div>

                            <div style="display: flex;">
                                <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">Last Name:</div>
                                <div style="padding: 5px 0; font-weight: bold;">{{ form.last_name }}</div>
                            </div>

                            <div style="display: flex;" v-if="form.name_suffix">
                                <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">Suffix:</div>
                                <div style="padding: 5px 0; font-weight: bold;">{{ form.name_suffix }}</div>
                            </div>

                            <div style="display: flex;" v-if="birthday.day && birthday.month && birthday.year">
                                <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">Date of Birth:</div>
                                <div style="padding: 5px 0; font-weight: bold;">{{ birthday.month }} / {{ birthday.day }} / {{ birthday.year }}</div>
                            </div>
                        </template>

                        <template v-if="isOrganization">
                            <div style="display: flex;">
                                <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">Name:</div>
                                <div style="padding: 5px 0; font-weight: bold;">{{ form.organization_name }}</div>
                            </div>

                            <div style="display: flex;" v-if="form.contact">
                                <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">Contact:</div>
                                <div style="padding: 5px 0; font-weight: bold;">{{ form.contact }}</div>
                            </div>
                        </template>
                    </div>

                    <div class="step-box" style="margin-bottom: 16px;">
                        <div class="step-title">Main Contact Information</div>

                        <div style="display: flex;">
                            <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">Address:</div>
                            <div style="padding: 5px 0; font-weight: bold;">{{ form.primaryContact.address_1 }}</div>
                        </div>

                        <div style="display: flex;" v-if="form.primaryContact.address_2">
                            <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">Address 2:</div>
                            <div style="padding: 5px 0; font-weight: bold;">{{ form.primaryContact.address_2 }}</div>
                        </div>

                        <div style="display: flex;">
                            <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">City:</div>
                            <div style="padding: 5px 0; font-weight: bold;">{{ form.primaryContact.city }}</div>
                        </div>

                        <div style="display: flex;">
                            <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">State / Province:</div>
                            <div style="padding: 5px 0; font-weight: bold;">{{ form.primaryContact.state }}</div>
                        </div>

                        <div style="display: flex;">
                            <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">Postal Code:</div>
                            <div style="padding: 5px 0; font-weight: bold;">{{ form.primaryContact.postal_code }}</div>
                        </div>

                        <div style="display: flex;" v-if="form.primaryContact.country">
                            <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">Country:</div>
                            <div style="padding: 5px 0; font-weight: bold;">{{ form.primaryContact.country }}</div>
                        </div>

                        <div style="display: flex;" v-if="form.primaryContact.phone">
                            <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">Phone:</div>
                            <div style="padding: 5px 0; font-weight: bold;">{{ form.primaryContact.phone }}</div>
                        </div>

                        <div style="display: flex;" v-if="form.primaryContact.cell_phone">
                            <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">Cell Phone:</div>
                            <div style="padding: 5px 0; font-weight: bold;">{{ form.primaryContact.cell_phone }}</div>
                        </div>

                        <div style="display: flex;" v-if="form.primaryContact.int_phone">
                            <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">Int'l. Phone:</div>
                            <div style="padding: 5px 0; font-weight: bold;">{{ form.primaryContact.int_phone }}</div>
                        </div>

                        <div style="display: flex;" v-if="form.email">
                            <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">Email:</div>
                            <div style="padding: 5px 0; font-weight: bold;">{{ form.email }}</div>
                        </div>

                        <div style="display: flex;" v-if="form.website">
                            <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">Website:</div>
                            <div style="padding: 5px 0; font-weight: bold;">{{ form.website }}</div>
                        </div>
                    </div>

                    <div class="step-box" style="margin-bottom: 16px;">
                        <div class="step-title">Site Access</div>

                        <div style="display: flex;">
                            <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">Login Name:</div>
                            <div style="padding: 5px 0; font-weight: bold;">{{ form.login }}</div>
                        </div>

                        <div style="display: flex;">
                            <div style="text-align: right; width: 100%; max-width: 200px; padding: 5px 15px;">Password:</div>
                            <div style="padding: 5px 0; font-weight: bold;">Not displayed for security reasons.</div>
                        </div>
                    </div>
                </template>

                <template v-if="form.step === 7">
                    <div class="step-box">
                        <div class="transaction-number">Your order number is: <span class="number" @click="print">{{ transaction.number }}</span></div>
                        <div class="print-invoice" @click="print">Print Sales Order</div>

                        <template v-if="transaction.payment_type === 'cash'">
                            <div class="checkout-title">DO NOT MAIL CASH. MEMBERSHIP STARTS WHEN CASH IS PROCESSED.</div>
                        </template>

                        <template v-if="transaction.payment_type === 'check'">
                            <div class="checkout-title">MAIL CHECK, MEMBERSHIP STARTS WHEN CHECK IS PROCESSED.</div>
                        </template>

                        <template v-if="transaction.payment_type === 'pay-pal' || transaction.payment_type === 'stripe'">
                            <div class="checkout-title">MEMBERSHIP STARTS IMMEDIATELY WHEN PAYMENT IS PROCESSED</div>
<!--                            <p style="text-align: center; margin-bottom: 16px;" v-if="transaction.payment_type === 'pay-pal'">Use PayPal as guest with credit card, or using PayPal account, membership starts immediately on payment.</p>-->
<!--                            <p style="text-align: center; margin-bottom: 16px;" v-if="transaction.payment_type === 'stripe'">Use Stripe with a credit card, membership starts immediately on payment.</p>-->
                            <div class="pay-button">
                                <a :href="transaction.url" target="_blank" style="display: block;">
                                    <img src="/images/pay-button.png" alt="Pay Now" style="width: 150px; height: auto;" />
                                </a>
                            </div>
                        </template>
                    </div>
                </template>

                <div style="text-align: right; padding: 8px 0;">
                    <button :disabled="isLoading" v-if="form.step > 1 && form.step < 7" type="button" @click="prevStep">Prev</button>
                    <button :disabled="isLoading" v-if="form.step < 6" type="button" @click="nextStep">Next</button>
                    <button :disabled="isLoading" v-if="form.step === 6" type="button" @click="nextStep">Confirm and Check Out</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import staticData from "../mixins/staticData";
import helpers from "../mixins/helpers";
import notifications from "../mixins/notifications";
import moment from "moment";
import { headerOffset } from "../mixins/headerOffset";
import publicSettings from "../mixins/publicSettings";

export default {
    name: "JoinFormComponent",
    mixins: [
        staticData,
        helpers,
        notifications,
        headerOffset,
        publicSettings,
    ],
    props: {
        plans: {
            type: Array,
            default: []
        },
        paymentMethods: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            publicSettingsGroups: ['payments', 'users'],
            isLoading: false,
            showPassword: false,
            showPasswordConfirmation: false,
            phoneFormatMask: '(###) ###-####',
            form: {
                step: 1,
                plan: null,
                name_prefix: '',
                name_suffix: '',
                first_name: null,
                last_name: '',
                middle_name: '',
                preferred_name: '',
                maiden_name: '',
                organization_name: null,
                contact: '',
                birthday: '',
                email: '',
                website: '',
                timezone: '',
                donation: 0,
                years: 1,
                payment_type: '',
                primaryContact: {
                    type: 'Primary',
                    country: '',
                    state: '',
                    city: '',
                    address_1: '',
                    address_2: '',
                    postal_code: '',
                    phone: '',
                    cell_phone: '',
                    int_phone: '',
                    phones_format_id: 1,
                },
                seasonalContact: {
                    uses_seasonal_contact: false,
                    type: 'Seasonal',
                    phone: '',
                    int_phone: '',
                    phones_format_id: 1,
                    country: '',
                    state: '',
                    city: '',
                    address_1: '',
                    address_2: '',
                    postal_code: '',
                    season_start_month: '',
                    season_start_day: '',
                    season_end_month: '',
                    season_end_day: '',
                },
            },
            birthday: {
                day: '',
                month: '',
                year: '',
            },
            transaction: {
                id: null,
                number: null,
                payment_type: null,
                url: null,
            },
            tax: 0,
            yearsError: ''
        }
    },
    computed: {
        maxYear() {
            return moment().format('YYYY');
        },
        isOrganization() {
            if (!this.form.plan) {
                return false
            }

            return this.plans.find(p => p.id === this.form.plan)?.type === 2;
        },
        selectedPlan() {
            return this.plans.find(p => p.id === this.form.plan) || { name: '', annual_fee: 0, actual_fee: 0 };
        },
        total() {
            const actualFee = Number(this.selectedPlan.actual_fee) || 0;
            const years = Number(this.form.years) || 1;
            const donation = Number(this.form.donation) || 0;
            const tax = Number(this.tax) || 0;

            return this.formatMoney((actualFee * years) + donation + tax);
        },
        availablePaymentMethods() {
            const methods = [];

            for (const key in this.paymentMethods) {
                if (this.paymentMethods[key].enabled) {
                    methods.push({
                        code: key,
                        name: this.paymentMethods[key].name
                    });
                }
            }

            return methods;
        },
        currency() {
            return this.getPublicSetting('currency') ?? 'USD';
        },
    },
    watch: {
        'form.donation': function (value) {
            if (value < 0) {
                this.form.donation = 0;
            }

            this.form.donation = +this.form.donation;

            if (this.form.donation > 999999) {
                this.form.donation = 999999;
            }
        },
        'form.plan': function () {
            this.normalizeYears();
            this.setTax();
        }
    },
    methods: {
        nextStep() {
            this.isLoading = true;

            if (this.form.step === 2) {
                if (this.birthday.year && this.birthday.month && this.birthday.day) {
                    this.form.birthday = `${this.birthday.year}-${this.birthday.month}-${this.birthday.day}`;
                } else {
                    this.form.birthday = null;
                }

                if (!this.isOrganization) {
                    delete this.form.organization_name;
                    delete this.form.contact;
                }

                if (this.isOrganization) {
                    delete this.form.first_name;
                    delete this.form.last_name;
                }
            }

            this.$api.post('/join-form', this.form).then(response => {
                if (response.data) {
                    this.clearValidateErrors();
                    this.form.step = response.data.step;

                    if (this.form.step === 7 && response.data.transaction) {
                        this.transaction = response.data.transaction;
                        this.transaction.url = response.data.url;
                        this.transaction.payment_type = response.data.payment_type;
                    }
                }
            }).catch((error) => {
                if (error.response && error.response.data.errors) {
                    this.setValidateErrors(error.response.data.errors);
                }
            }).finally(() => {
                this.isLoading = false;
            });

            this.$refs.startForm.scrollIntoView({ behavior: 'smooth' });
        },
        prevStep() {
            if (this.form.step === 5 && !this.form.seasonalContact.uses_seasonal_contact) {
                this.form.step -= 2;
            } else {
                this.form.step--;
            }

            this.$refs.startForm.scrollIntoView({ behavior: 'smooth' });
        },
        checkBirthday() {
            if (this.birthday.year !== '' && this.birthday.year < 1000) {
                this.birthday.year = 1000;
            }
            if (this.birthday.year !== '' && this.birthday.year > this.maxYear) {
                this.birthday.year = this.maxYear;
            }
        },
        print() {
            this.loading = true;
                this.$api.post('/join-form/print-invoice/' + this.transaction.id, {}, {
                responseType: 'blob'
            }).then(response => {
                if (response.data) {
                    const link = document.createElement('a');
                    const blob = new Blob([response.data], { type: 'application/pdf' });
                    link.href = window.URL.createObjectURL(blob);
                    window.open(link.href);
                    link.download = 'order-' + this.transaction.number + '.pdf';
                    document.body.appendChild(link);
                    // link.click();

                    document.body.removeChild(link);
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        clearData() {
            this.form = {
                step: 1,
                plan: null,
                name_prefix: '',
                name_suffix: '',
                first_name: null,
                last_name: '',
                middle_name: '',
                preferred_name: '',
                maiden_name: '',
                organization_name: null,
                contact: '',
                birthday: '',
                address_1: '',
                address_2: '',
                city: '',
                state: '',
                postal_code: '',
                country: '',
                phones_format_id: 1,
                phone: '',
                cell_phone: '',
                int_phone: '',
                email: '',
                website: '',
                donation: 0,
                payment_type: '',
                tax: 0,
            };

            this.birthday = {
                day: '',
                month: '',
                year: '',
            };
        },
        setTax() {
            this.isLoading = true;
            this.$api.get('/join-form/plan-fee', {
                params: {
                    plan_id: this.selectedPlan.id,
                    years: this.form.years || 1,
                }
            }).then(response => {
                if (response.data) {
                    this.tax = response.data.tax;
                }
            }).finally(() => {
                this.isLoading = false;
            });
        },
        handlePlanChange(event) {
            this.setTax();
        },
        normalizeYears() {
            const maxYears = Number(this.selectedPlan.max_renewal_years) || 1;

            this.yearsError = '';

            if (!this.form.years || this.form.years < 1) {
                this.form.years = 1;
                this.yearsError = 'The minimum number of years is 1.';

                return;
            }

            if (this.form.years > maxYears) {
                this.form.years = maxYears;
                this.yearsError = `The maximum number of years is ${maxYears}.`;
            }
        }
    }
}
</script>

<style scoped lang="scss">
.join-section {
    width: 100%;

    input, select {
        height: 34px!important;
    }

    button {
        background: #ffffff;
        min-width: 100px;
        border: 1px solid #000000;
        border-radius: 4px;
    }

    button:hover {
        background: #f0f0f0;
    }

    button:disabled {
        background: #f0f0f0;
        cursor: not-allowed;
    }

    .title-table {
        font-size: 1.2em;
        font-weight: bold;
    }

    .join-title {
        font-size: 1.5em;
        text-align: center;
    }

    .join-form {
        margin: 20px 0 40px 0;
    }

    .step-title {
        font-size: 1.2em;
        font-weight: bold;
        margin-bottom: 30px;
        border-bottom: 1px solid #ccc;
    }

    .step-box {
        padding-bottom: 30px;
        border-bottom: 1px solid #ccc;
    }

    .plans-table-wrap {
        overflow-x: auto;
        padding-bottom: 8px;
        -webkit-overflow-scrolling: touch;
    }

    .plans-table {
        border-collapse: collapse;
        width: 100%;
        min-width: 600px;

        tr {
            border-bottom: 1px solid #ccc;

            td {
                padding: 10px 15px;
            }
        }
    }

    .plans-table thead {
        font-size: 0.8em;
        font-weight: bold;
        td {
            white-space: normal !important;
            min-width: 80px;
        }
    }

    .error-messages {
        color: red;
        font-size: 0.8em;
        line-height: 1.5;
    }

    .hint-messages {
        color: grey;
        font-size: 0.8em;
        line-height: 1.5;
    }

    .field-box {
        display: flex;
        flex-direction: column;
        margin-bottom: 8px;
    }

    .field-label {
        display: block;
    }

    .field-required {
        color: red;
    }

    .checkout-title {
        font-size: 1.4em;
        margin-bottom: 16px;
        color: green;
        text-align: center;
    }

    .transaction-number {
        font-size: 1.2em;
        margin-bottom: 16px;
        text-align: center;
    }

    .number {
        cursor: pointer;
        font-weight: bold;
    }

    .print-invoice {
        font-size: 1.4em;
        margin-bottom: 16px;
        text-align: center;
        font-weight: bold;
        cursor: pointer;
    }

    .pay-title {
        font-size: 1.2em;
        margin-bottom: 16px;
        text-align: center;
    }

    .pay-button {
        text-align: center;
        margin-bottom: 16px;
    }

    .fields-wrap {
        width: 100%;
        max-width: 350px;
        margin: 0 auto;
    }

    .field-element {
        width: 100%;
        max-width: 350px;
    }

    .password-field {
        position: relative;

        input {
            width: 100%;
            padding-right: 42px;
        }

        .password-toggle {
            position: absolute;
            top: 9px;
            right: 12px;
            color: #777;
            cursor: pointer;
            font-size: 16px;
        }

        .password-toggle:hover {
            color: #222;
        }
    }

    .date-select-row {
        display: flex;
        gap: 10px;
        align-items: center;
    }

    .date-select {
        display: flex;
        flex-direction: column;
        max-height: 200px;
        overflow-y: auto;
    }
}
</style>
